import { createReducer, on } from '@ngrx/store';
import * as ActionBarPortalActions from './action-bar-portal.actions';
import { ActionBarPortalState } from './action-bar-portal.models';

export const initialActionBarPortalState: ActionBarPortalState = {
  portal: null,
  forceLayoutClass: false,
};

export const actionBarPortalReducer = createReducer(
  initialActionBarPortalState,
  on(ActionBarPortalActions.setActionBarPortal, (_, { portal, forceLayoutClass }) => ({
    portal,
    forceLayoutClass,
  })),
  on(ActionBarPortalActions.forceActionBarLayoutClass, (state) => ({
    ...state,
    forceLayoutClass: true,
  })),
  on(ActionBarPortalActions.clearActionBarPortal, () => initialActionBarPortalState),
);
